import { render, staticRenderFns } from "./dialog-table-av.vue?vue&type=template&id=13ba3638&scoped=true"
import script from "./dialog-table-av.vue?vue&type=script&lang=js"
export * from "./dialog-table-av.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba3638",
  null
  
)

export default component.exports